export default {
  body: {
    backgroundColor: 'neutral.100',
    color: 'gray.800',
    minHeight: 'h-screen',
  },
  html: {scrollBehavior: 'smooth'},
}
